/* ── EXIT LOOP THEME JS ── */

// ── CART STATE ──
let cart = { items: [], total: 0 };

// ── CART DRAWER ──
function openCart() {
  document.getElementById('cart-drawer').classList.add('is-open');
  document.getElementById('cart-overlay').classList.add('is-active');
  document.body.style.overflow = 'hidden';
  fetchCart();
}

function closeCart() {
  document.getElementById('cart-drawer').classList.remove('is-open');
  document.getElementById('cart-overlay').classList.remove('is-active');
  document.body.style.overflow = '';
}

// ── FETCH CART FROM SHOPIFY ──
async function fetchCart() {
  try {
    const res = await fetch('/cart.js');
    const data = await res.json();
    renderCart(data);
  } catch (e) {
    console.error('Cart fetch failed:', e);
  }
}

function renderCart(data) {
  const itemsEl = document.getElementById('cart-items');
  const footerEl = document.getElementById('cart-footer');
  const countEl = document.getElementById('cart-count');
  const totalEl = document.getElementById('cart-total-price');

  if (countEl) countEl.textContent = data.item_count;

  if (data.item_count === 0) {
    itemsEl.innerHTML = `
      <div class="cart-drawer__empty">
        <p>Your bag is empty.</p>
        <a href="/collections/all" class="btn btn--primary" onclick="closeCart()">Shop Now</a>
      </div>`;
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  itemsEl.innerHTML = data.items.map((item, i) => `
    <div class="cart-item" data-key="${item.key}">
      <div class="cart-item__image">
        ${item.image ? `<img src="${item.image}" alt="${item.title}">` : ''}
      </div>
      <div class="cart-item__details">
        <div class="cart-item__name">${item.product_title}</div>
        <div class="cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
        <div class="cart-item__price">${formatMoney(item.final_price)}</div>
        <div class="cart-item__qty">
          <button class="cart-item__qty-btn" onclick="updateCartQty('${item.key}', ${item.quantity - 1})">−</button>
          <span class="cart-item__qty-num">${item.quantity}</span>
          <button class="cart-item__qty-btn" onclick="updateCartQty('${item.key}', ${item.quantity + 1})">+</button>
        </div>
      </div>
    </div>
  `).join('');

  if (totalEl) totalEl.textContent = formatMoney(data.total_price);
  if (footerEl) footerEl.style.display = 'flex';
  const cartBanner = document.getElementById('exl12-cart-banner');
  if (cartBanner) cartBanner.style.display = data.item_count >= 2 ? 'block' : 'none';
}

// ── ADD TO CART ──
async function addToCart(variantId, title, price) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (res.ok) {
      await fetchCart();
      openCart();
    }
  } catch (e) {
    console.error('Add to cart failed:', e);
  }
}

// ── QUICK ADD (from product grid) ──
function quickAdd(event, variantId, title, price) {
  event.preventDefault();
  event.stopPropagation();
  addToCart(variantId, title, price);
}

// ── REMOVE FROM CART ──
async function removeFromCart(itemKey) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    });
    const data = await res.json();
    if (data.item_count !== undefined) {
      renderCart(data);
    } else {
      fetchCart();
    }
  } catch (e) {
    console.error('Remove from cart failed:', e);
    fetchCart();
  }
}

// ── UPDATE CART QUANTITY ──
async function updateCartQty(itemKey, newQty) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: newQty })
    });
    const data = await res.json();
    if (data.item_count !== undefined) {
      renderCart(data);
    } else {
      fetchCart();
    }
  } catch (e) {
    fetchCart();
  }
}

// ── FORMAT MONEY ──
function formatMoney(cents) {
  return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
}

// ── MOBILE NAV ──
function openMobileNav() {
  document.getElementById('mobile-nav').classList.add('is-open');
  document.body.style.overflow = 'hidden';
}

function closeMobileNav() {
  document.getElementById('mobile-nav').classList.remove('is-open');
  document.body.style.overflow = '';
}

// ── SIZE SELECTOR (product page) ──
function selectSize(btn) {
  document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('is-selected'));
  btn.classList.add('is-selected');
  const addBtn = document.getElementById('add-to-cart-btn');
  if (addBtn) {
    addBtn.dataset.variantId = btn.dataset.variantId;
  }
}

// ── INIT: load cart count on page load ──
document.addEventListener('DOMContentLoaded', () => {
  fetch('/cart.js')
    .then(r => r.json())
    .then(data => {
      const countEl = document.getElementById('cart-count');
      if (countEl) countEl.textContent = data.item_count;
    })
    .catch(() => {});
});

// ── PRODUCT CARD GALLERY (hover + swipe) ──
function initCardGalleries() {
  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const slides = gallery.querySelectorAll('.product-card__slide');
    const dots = gallery.querySelectorAll('.product-card__dot');
    if (slides.length < 2) return;

    let current = 0;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      dots[current]?.classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      dots[current]?.classList.add('is-active');
    }

    // Dot clicks
    dots.forEach(dot => {
      dot.addEventListener('click', e => {
        e.preventDefault();
        goTo(parseInt(dot.dataset.index));
      });
    });

    // Arrow clicks
    const arrows = gallery.querySelectorAll('.product-card__arrow');
    arrows.forEach(arrow => {
      arrow.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        goTo(current + parseInt(arrow.dataset.nav));
      });
    });

    const card = gallery.closest('.product-card__image-wrap');

    // Mobile swipe
    let touchStartX = 0;
    let touchStartY = 0;
    let swipeHandled = false;
    gallery.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      swipeHandled = false;
    }, { passive: true });
    gallery.addEventListener('touchend', e => {
      const diffX = touchStartX - e.changedTouches[0].clientX;
      const diffY = Math.abs(e.changedTouches[0].clientY - touchStartY);
      if (Math.abs(diffX) > 30 && Math.abs(diffX) > diffY) {
        e.preventDefault();
        e.stopPropagation();
        swipeHandled = true;
        goTo(diffX > 0 ? current + 1 : current - 1);
      }
    });
    card.addEventListener('click', e => {
      if (swipeHandled) { e.preventDefault(); swipeHandled = false; }
    });
  });
}

document.addEventListener('DOMContentLoaded', initCardGalleries);

// ── CUSTOM REVIEW SYSTEM ──
const CLOUD_NAME = 'gwp6ufd4';
const UPLOAD_PRESET = 'review';

async function uploadToCloudinary(file) {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('upload_preset', UPLOAD_PRESET);
  const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, { method: 'POST', body: fd });
  const data = await res.json();
  return data.secure_url;
}

function openPhotoLightbox(url) {
  const lb = document.createElement('div');
  lb.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.95);z-index:9999;display:flex;align-items:center;justify-content:center;cursor:pointer';
  lb.innerHTML = `<img src="${url}" style="max-width:90vw;max-height:90vh;object-fit:contain">`;
  lb.onclick = () => lb.remove();
  document.body.appendChild(lb);
}

// ── PRODUCT PAGE REVIEWS ──
const PROD_REV_PER_PAGE = 5;
let prodRevData = null;
let prodRevPage = {};
let prodRevSort = {};

async function loadProdReviews() {
  const lists = document.querySelectorAll('[id^="prod-rev-list-"]');
  if (lists.length === 0) return;
  const tryLoad = async () => {
    if (!window.db) { setTimeout(tryLoad, 200); return; }
    try {
      const snap = await window.db.collection('reviews').get();
      prodRevData = snap.docs.map(d => d.data());
      lists.forEach(el => {
        const productId = el.id.replace('prod-rev-list-', '');
        prodRevSort[productId] = 'newest';
        prodRevPage[productId] = 1;
        renderProdReviews(productId, 1);
      });
    } catch(e) {
      lists.forEach(el => { el.innerHTML = '<p class="rev-empty">Could not load reviews.</p>'; });
    }
  };
  tryLoad();
}

function sortProdRevs(reviews, sort) {
  const r = [...reviews];
  if (sort === 'newest') return r.sort((a, b) => new Date(b.date) - new Date(a.date));
  if (sort === 'oldest') return r.sort((a, b) => new Date(a.date) - new Date(b.date));
  if (sort === 'highest') return r.sort((a, b) => b.rating - a.rating);
  if (sort === 'lowest') return r.sort((a, b) => a.rating - b.rating);
  return r;
}

function renderProdReviews(productId, page) {
  const list = document.getElementById(`prod-rev-list-${productId}`);
  if (!list || !prodRevData) return;
  const sort = prodRevSort[productId] || 'newest';
  const sorted = sortProdRevs(prodRevData, sort);
  const totalPages = Math.ceil(sorted.length / PROD_REV_PER_PAGE);
  const start = (page - 1) * PROD_REV_PER_PAGE;
  const pageRevs = sorted.slice(start, start + PROD_REV_PER_PAGE);

  if (sorted.length === 0) {
    list.innerHTML = '<p class="rev-empty">No reviews yet. Be the first!</p>';
    return;
  }

  const avg = (prodRevData.reduce((s, r) => s + r.rating, 0) / prodRevData.length).toFixed(1);
  list.innerHTML = `
    <div class="rev-summary">
      <span class="rev-avg">${avg}</span>
      <span class="rev-avg-stars">${'★'.repeat(Math.round(avg))}${'☆'.repeat(5 - Math.round(avg))}</span>
      <span class="rev-count">${prodRevData.length} review${prodRevData.length !== 1 ? 's' : ''}</span>
    </div>
    ${pageRevs.map(r => `
      <div class="rev-item">
        <div class="rev-item__head">
          <span class="rev-item__stars">${'★'.repeat(r.rating)}${'☆'.repeat(5 - r.rating)}</span>
          <span class="rev-item__name">${r.name}</span>
          <span class="rev-item__date" style="margin-left:auto">${new Date(r.date).toLocaleDateString('en-IN', {day:'numeric',month:'short',year:'numeric'})}</span>
        </div>
        ${r.product ? `<p style="font-size:10px;letter-spacing:0.1em;text-transform:uppercase;color:var(--muted);margin-bottom:6px">${r.product}</p>` : ''}
        <p class="rev-item__body">${r.body}</p>
        ${r.photos && r.photos.length > 0 ? `
          <div class="rev-item__photos">
            ${r.photos.map(url => `<img src="${url}" alt="Review photo" onclick="openPhotoLightbox('${url}')">`).join('')}
          </div>` : ''}
      </div>
    `).join('')}
    ${totalPages > 1 ? `
    <div class="all-reviews__pagination">
      <button class="all-reviews__page-btn" onclick="changeProdRevPage('${productId}', ${page - 1})" ${page <= 1 ? 'disabled' : ''}>← Prev</button>
      <span class="all-reviews__page-info">${page} / ${totalPages}</span>
      <button class="all-reviews__page-btn" onclick="changeProdRevPage('${productId}', ${page + 1})" ${page >= totalPages ? 'disabled' : ''}>Next →</button>
    </div>` : ''}
  `;
}

function changeProdRevPage(productId, page) {
  prodRevPage[productId] = page;
  renderProdReviews(productId, page);
  document.getElementById(`prod-rev-list-${productId}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function changeProdRevSort(productId, sort) {
  prodRevSort[productId] = sort;
  prodRevPage[productId] = 1;
  renderProdReviews(productId, 1);
}

document.addEventListener('DOMContentLoaded', loadProdReviews);
